"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const CardedQuery_1 = require("../../CardedQuery");
const graphql_1 = require("../../../../graphql");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_if_1 = require("react-if");
const AdminOnly_1 = require("../../../../comps/reusables/AdminOnly");
const OnlyWhenWorkspaceSetting_1 = require("../../../../comps/reusables/OnlyWhenWorkspaceSetting");
const CenteredRow_1 = require("../../../../comps/reusables/CenteredRow");
const svg_1 = require("../../../../svg");
const react_router_dom_1 = require("react-router-dom");
const inputs_1 = require("../../../../inputs");
const utils_1 = require("@osmosys/utils");
const react_hooks_1 = require("@apollo/react-hooks");
exports.EspHome = ({ integration }) => {
    if (!integration) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const canConnect = integration.integrationType === 'Salesforce'
        ? integration.canConnectToREST &&
            integration.canConnectToSOAP
        : integration.canConnect;
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EspHome" },
        react_1.default.createElement(reactstrap_1.Row, { className: "mb-2" },
            react_1.default.createElement(reactstrap_1.Col, { md: 7 },
                react_1.default.createElement(react_if_1.If, { condition: !!canConnect },
                    react_1.default.createElement(react_if_1.Then, null,
                        react_1.default.createElement(exports.EspHomeLists, { esp: integration }),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(exports.EspHomeCampaigns, { esp: integration }),
                        react_1.default.createElement("br", null)),
                    react_1.default.createElement(react_if_1.Else, null,
                        react_1.default.createElement(reactstrap_1.Alert, { color: "primary" },
                            react_1.default.createElement(CenteredRow_1.CenteredRow, null, [
                                {
                                    grow: false,
                                    render: (react_1.default.createElement("div", { className: "mr-3" },
                                        react_1.default.createElement(svg_1.IntegrationsLogo, { width: 60, height: 60 }))),
                                },
                                {
                                    grow: true,
                                    render: (react_1.default.createElement("div", null,
                                        react_1.default.createElement("strong", null,
                                            "Not connected to ",
                                            integration.displayType),
                                        react_1.default.createElement("br", null),
                                        react_1.default.createElement(AdminOnly_1.AdminOnly, { workspaceAdminsAlso: true, fallback: "Contact a workspace admin or email support@yellowbrim.com for assistance." }, "Continue setting up this integration in the Settings page."))),
                                },
                            ]))))),
            react_1.default.createElement(reactstrap_1.Col, { md: 5 },
                react_1.default.createElement(exports.EspConnectionStatusCard, { canConnect: canConnect, esp: integration }),
                react_1.default.createElement("br", null),
                react_1.default.createElement(EspSubscriberToolsCard, { esp: integration })))));
};
const useActivateEmailLists = (opts) => {
    const [activateEmailLists, activateEmailListsResult] = react_hooks_1.useMutation(graphql_1.activateEmailLists, opts);
    return { activateEmailLists, activateEmailListsResult };
};
const EspListSelectCard = ({ esp }) => {
    var _a;
    const [list, setList] = react_1.useState(null);
    const [segments, setSegments] = react_1.useState([]);
    const saveData = react_1.useMemo(() => list
        ? {
            emailSegments: segments.map(segment => {
                return {
                    espId: segment.espId,
                    id: segment.id,
                    name: segment.name,
                };
            }),
            espId: list.espId,
            id: list.id,
            name: list.name,
        }
        : null, [list]);
    const { activateEmailLists, activateEmailListsResult, } = useActivateEmailLists({
        variables: {
            data: [saveData],
        },
    });
    return (react_1.default.createElement(AdminOnly_1.AdminOnly, null,
        react_1.default.createElement(react_if_1.When, { condition: esp.integrationType === 'Mailchimp' },
            react_1.default.createElement(reactstrap_1.Card, { body: true },
                react_1.default.createElement(CenteredRow_1.CenteredRow, null, [
                    {
                        grow: true,
                        render: (react_1.default.createElement("p", { className: "lead m-0" },
                            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "slot", className: "mr-2" }),
                            "Activate new list")),
                    },
                    {
                        grow: false,
                        render: (react_1.default.createElement("p", { className: "text-small text-danger m-0" },
                            react_1.default.createElement(react_2.OsmosysTooltip, { label: "App admins only" },
                                react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "appAdminsOnly" })))),
                    },
                ]),
                react_1.default.createElement("br", null),
                react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "emailList", espId: esp.id, value: list, onChange: setList, activated: false }),
                react_1.default.createElement(reactstrap_1.Collapse, { isOpen: utils_1.isDefined(list) },
                    react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "emailSegment", listEspId: (_a = list) === null || _a === void 0 ? void 0 : _a.espId, espId: esp.id, value: segments, onChange: setSegments, activated: false, multiple: true })),
                react_1.default.createElement(reactstrap_1.Collapse, { isOpen: utils_1.isDefined(list) },
                    react_1.default.createElement(react_2.OsmosysButton, { osysName: "activateEmailLists", mutationResult: activateEmailListsResult, mutate: activateEmailLists }, "Enable email selected list & segments"))),
            react_1.default.createElement("br", null))));
};
const EspSubscriberToolsCard = ({ esp }) => {
    const tabs = [];
    tabs.push({
        id: 'subscribers-download',
        name: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "download", marginRight: true }),
            "Download")),
        to: `/integrations/${esp.id}/subscribers/download`,
    });
    tabs.push({
        id: 'subscribers-update',
        name: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "upload", marginRight: true }),
            "Update")),
        to: `/integrations/${esp.id}/subscribers/update`,
    });
    return (react_1.default.createElement(AdminOnly_1.AdminOnly, { workspaceAdminsAlso: true },
        react_1.default.createElement(react_if_1.When, { condition: esp.integrationType === 'Mailchimp' },
            react_1.default.createElement(reactstrap_1.Card, { body: true },
                react_1.default.createElement(CenteredRow_1.CenteredRow, null, [
                    {
                        grow: true,
                        render: (react_1.default.createElement("p", { className: "lead m-0" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faMailBulk, className: "mr-2" }),
                            ' ',
                            "Subscriber tools")),
                    },
                    {
                        grow: false,
                        render: (react_1.default.createElement("p", { className: "text-small text-danger m-0" },
                            react_1.default.createElement(react_2.OsmosysTooltip, { label: "Workspace admins only" },
                                react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "workspaceAdminsOnly" })))),
                    },
                ]),
                react_1.default.createElement("br", null),
                react_1.default.createElement(OnlyWhenWorkspaceSetting_1.OnlyWhenWorkspaceSetting, { enableSubscriberTools: true, fallback: react_1.default.createElement("p", { className: "mb-0 text-center" },
                        "Contact",
                        ' ',
                        react_1.default.createElement("a", { href: `mailto:${'support@yellowbrim.com'}?subject=${encodeURIComponent('Mailchimp subscriber tools')}`, target: "_blank", rel: "noopener noreferrer" }, "support"),
                        ' ',
                        "to request access to this feature.") },
                    react_1.default.createElement(reusables_1.NavPills, { center: true, queryDetailLayout: true, tabs: tabs, marginBottom: false }))))));
};
exports.EspHomeLists = ({ esp }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EspHomeLists" },
        react_1.default.createElement(CardedQuery_1.CardedQuery, { max: -1, label: "Activated subscriber lists", prefKey: "emailLists", query: graphql_1.emailLists, position: "start", variables: {
                integrationId: esp.id,
            }, skip: !esp.id, hideable: false, showFailState: true, pathToItems: "emailLists", pathToName: d => (react_1.default.createElement(react_1.default.Fragment, null, d.name ? `${d.name} (ID: ${d.id})` : `List #${d.id}`)) })));
};
exports.EspHomeCampaigns = ({ esp: { id } }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EspHomeCampaigns" },
        react_1.default.createElement(CardedQuery_1.CardedQuery, { max: -1, label: "Email campaigns", prefKey: "emailCampaigns", query: graphql_1.emailCampaigns, position: "start", variables: {
                emailServiceProviderId: id,
            }, hideable: false, showFailState: true, pathToItems: "emailCampaigns", pathToName: d => (react_1.default.createElement(react_1.default.Fragment, null, d.name ? `${d.name} (ID: ${d.id})` : `Campaign #${d.id}`)) })));
};
exports.EspHomeOsmosysEmails = () => {
    return react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EspHomeOsmosysEmails" });
};
exports.EspConnectionStatusCard = ({ esp: { id }, canConnect }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EspConnectionStatusCard" },
        react_1.default.createElement(reactstrap_1.Card, { body: true },
            react_1.default.createElement(reusables_1.ConnectionStatus, { canConnect: canConnect, large: true }),
            react_1.default.createElement(react_if_1.When, { condition: !canConnect },
                react_1.default.createElement(AdminOnly_1.AdminOnly, { workspaceAdminsAlso: true },
                    react_1.default.createElement("p", { className: "mt-2 mb-0" },
                        react_1.default.createElement(react_router_dom_1.Link, { to: `/integrations/${id}/settings` }, "Add an access key in settings")))))));
};
//# sourceMappingURL=index.js.map